import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-67b076f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "select-outcome"
}
const _hoisted_2 = {
  class: "text-center",
  "data-test": "select-outcome-title"
}
const _hoisted_3 = {
  key: 0,
  class: "outcome-page-header"
}
const _hoisted_4 = {
  key: 1,
  class: "outcome-page-header"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "outcome-subtitle" }, "As a team we want to be more...", -1))

import { ref, onBeforeMount } from "vue";
import { TimelineMax } from "gsap";
import { useRoute } from "vue-router";
import OutcomeTile from "./outcome-tile.vue";
import {
  CmsDocumentTypes,
  CmsTeamGoal,
  CmsGoalData,
} from "../../services/cms/cms-type-definitions";
import cms from "../../services/cms/cms";
import OutcomeModal from "./outcome-modal.vue";
import LoadingPage from "../../views/loading-page.vue";
import { Analytics } from "../../services/analytics/analytics";
import { OutcomeType } from "./outcome-type.enum";


export default /*#__PURE__*/_defineComponent({
  __name: 'select-team-outcome',
  props: {
    isTeamLeaderOrOrgAdmin: { type: Boolean }
  },
  emits: ["update-stepper"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const outcomeModal = ref<InstanceType<typeof OutcomeModal> | null>(null);

const teamId = ref("");

const isLoading = ref(true);

const outcomes = ref<Record<OutcomeType, CmsTeamGoal | null>>({
  entrepreneurial: null,
  innovative: null,
  inspirational: null,
  resilient: null,
  growth: null,
  collaborative: null,
  agile: null,
  strategic: null,
  inclusive: null,
});

const selectedOutcome = ref<CmsGoalData | null>(null);

const selectedOutcomeUid = ref("");

function openModal(outcome: CmsTeamGoal): void {
  selectedOutcome.value = outcome.data;
  selectedOutcomeUid.value = outcome.uid ?? "";
  Analytics.action("Clicked Team Outcome", "TeamPathwayActions", {
    outcomeUid: selectedOutcomeUid.value,
    outcomeName: cms.asText(selectedOutcome.value.name),
    outcomeTitle: cms.asText(selectedOutcome.value.full_title),
  });
  outcomeModal.value?.openModal();
}

function beforeEnter(element: HTMLDivElement): void {
  element.style.opacity = "0";
  element.style.transform = "translateY(50px)";
}

function enter(element: HTMLDivElement, done: boolean): void {
  const tl = new TimelineMax({});
  let delay: number;
  if (typeof element.dataset.index !== "undefined") {
    delay = +element.dataset.index;
    tl.to(
      element,
      0.8,
      {
        opacity: 1,
        y: 0,
        onComplete: done,
        delay: delay * 0.1,
      },
      0,
    );
  }
}

function mapOutcomes(cmsOutcomes: CmsTeamGoal[]): void {
  const keys = Object.values(OutcomeType);
  keys.forEach((key) => {
    outcomes.value[key] = cmsOutcomes.find((g) => g.uid?.includes(key)) ?? null;
  });
}

const route = useRoute();

onBeforeMount(async () => {
  teamId.value = route.params.id as string;
  const response = await cms.getAll(CmsDocumentTypes.CmsTeamGoal);
  mapOutcomes(response.filter((r) => r.data.journey === "team"));
  isLoading.value = false;
  emit("update-stepper", route.name);
});

return (_ctx: any,_cache: any) => {
  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createVNode(OutcomeModal, {
          ref_key: "outcomeModal",
          ref: outcomeModal,
          outcomeUid: selectedOutcomeUid.value,
          outcome: selectedOutcome.value
        }, null, 8, ["outcomeUid", "outcome"]),
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isTeamLeaderOrOrgAdmin)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_3, "Choose your Team Outcome"))
            : (_openBlock(), _createElementBlock("h1", _hoisted_4, "Browse Team Outcomes")),
          _hoisted_5
        ]),
        _createVNode(_TransitionGroup, {
          tag: "div",
          appear: "",
          onBeforeEnter: beforeEnter,
          onEnter: enter,
          class: "outcome-grid",
          "data-test": "outcome-grid"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "grid-tile",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (outcomes.value.entrepreneurial && openModal(outcomes.value.entrepreneurial))),
              onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (outcomes.value.entrepreneurial && openModal(outcomes.value.entrepreneurial)), ["enter"])),
              key: "entrepreneurial",
              "data-index": "1",
              tabindex: "0"
            }, [
              _createVNode(OutcomeTile, {
                outcome: outcomes.value.entrepreneurial?.data,
                "data-test": "entrepreneurial-tile"
              }, null, 8, ["outcome"])
            ], 32),
            _createElementVNode("div", {
              class: "grid-tile",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (outcomes.value.innovative && openModal(outcomes.value.innovative))),
              onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (outcomes.value.innovative && openModal(outcomes.value.innovative)), ["enter"])),
              key: "innovative",
              "data-index": "2",
              tabindex: "0"
            }, [
              _createVNode(OutcomeTile, {
                outcome: outcomes.value.innovative?.data,
                "data-test": "innovative-tile"
              }, null, 8, ["outcome"])
            ], 32),
            _createElementVNode("div", {
              class: "grid-tile",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (outcomes.value.inspirational && openModal(outcomes.value.inspirational))),
              onKeydown: _cache[5] || (_cache[5] = _withKeys(($event: any) => (outcomes.value.inspirational && openModal(outcomes.value.inspirational)), ["enter"])),
              key: "inspirational",
              "data-index": "3",
              tabindex: "0"
            }, [
              _createVNode(OutcomeTile, {
                outcome: outcomes.value.inspirational?.data,
                "data-test": "inspirational-tile"
              }, null, 8, ["outcome"])
            ], 32),
            _createElementVNode("div", {
              class: "grid-tile",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (outcomes.value.resilient && openModal(outcomes.value.resilient))),
              onKeydown: _cache[7] || (_cache[7] = _withKeys(($event: any) => (outcomes.value.resilient && openModal(outcomes.value.resilient)), ["enter"])),
              key: "resilient",
              "data-index": "4",
              tabindex: "0"
            }, [
              _createVNode(OutcomeTile, {
                outcome: outcomes.value.resilient?.data,
                "data-test": "resilient-tile"
              }, null, 8, ["outcome"])
            ], 32),
            _createElementVNode("div", {
              class: "grid-tile",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (outcomes.value.growth && openModal(outcomes.value.growth))),
              onKeydown: _cache[9] || (_cache[9] = _withKeys(($event: any) => (outcomes.value.growth && openModal(outcomes.value.growth)), ["enter"])),
              key: "growth",
              "data-index": "5",
              tabindex: "0"
            }, [
              _createVNode(OutcomeTile, {
                outcome: outcomes.value.growth?.data,
                "data-test": "growth-tile"
              }, null, 8, ["outcome"])
            ], 32),
            _createElementVNode("div", {
              class: "grid-tile",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (outcomes.value.collaborative && openModal(outcomes.value.collaborative))),
              onKeydown: _cache[11] || (_cache[11] = _withKeys(($event: any) => (outcomes.value.collaborative && openModal(outcomes.value.collaborative)), ["enter"])),
              key: "collaborative",
              "data-index": "6",
              tabindex: "0"
            }, [
              _createVNode(OutcomeTile, {
                outcome: outcomes.value.collaborative?.data,
                "data-test": "collaborative-tile"
              }, null, 8, ["outcome"])
            ], 32),
            _createElementVNode("div", {
              class: "grid-tile",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (outcomes.value.agile && openModal(outcomes.value.agile))),
              onKeydown: _cache[13] || (_cache[13] = _withKeys(($event: any) => (outcomes.value.agile && openModal(outcomes.value.agile)), ["enter"])),
              key: "agile",
              "data-index": "7",
              tabindex: "0"
            }, [
              _createVNode(OutcomeTile, {
                outcome: outcomes.value.agile?.data,
                "data-test": "agile-tile"
              }, null, 8, ["outcome"])
            ], 32),
            _createElementVNode("div", {
              class: "grid-tile",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (outcomes.value.strategic && openModal(outcomes.value.strategic))),
              onKeydown: _cache[15] || (_cache[15] = _withKeys(($event: any) => (outcomes.value.strategic && openModal(outcomes.value.strategic)), ["enter"])),
              key: "strategic",
              "data-index": "8",
              tabindex: "0"
            }, [
              _createVNode(OutcomeTile, {
                outcome: outcomes.value.strategic?.data,
                "data-test": "strategic-tile"
              }, null, 8, ["outcome"])
            ], 32),
            _createElementVNode("div", {
              class: "grid-tile",
              onClick: _cache[16] || (_cache[16] = ($event: any) => (outcomes.value.inclusive && openModal(outcomes.value.inclusive))),
              onKeydown: _cache[17] || (_cache[17] = _withKeys(($event: any) => (outcomes.value.inclusive && openModal(outcomes.value.inclusive)), ["enter"])),
              key: "inclusive",
              "data-index": "9",
              tabindex: "0"
            }, [
              _createVNode(OutcomeTile, {
                outcome: outcomes.value.inclusive?.data,
                "data-test": "inclusive-tile"
              }, null, 8, ["outcome"])
            ], 32)
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createBlock(LoadingPage, { key: 1 }))
}
}

})